/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * as createTemplate from './communication/createTemplate.js'
export * as deleteTemplate from './communication/deleteTemplate.js'
export * as listTemplates from './communication/listTemplates.js'
export * as updateTemplate from './communication/updateTemplate.js'
export * as defs from './communication/defs.js'
